import { render, staticRenderFns } from "./LoginBtn.vue?vue&type=template&id=53681467&scoped=true"
import script from "./LoginBtn.vue?vue&type=script&lang=js"
export * from "./LoginBtn.vue?vue&type=script&lang=js"
import style0 from "./LoginBtn.vue?vue&type=style&index=0&id=53681467&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53681467",
  null
  
)

export default component.exports